/**
 * @generated SignedSource<<5cf0c18ba8b31667aa927ba4192d8f4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpSubSitesProviderQuery$variables = {
  siteUrl: string;
};
export type SpSubSitesProviderQuery$data = {
  readonly getSharePointSubsites: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
    readonly url: string;
  }> | null | undefined;
};
export type SpSubSitesProviderQuery = {
  response: SpSubSitesProviderQuery$data;
  variables: SpSubSitesProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteUrl"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "siteUrl",
        "variableName": "siteUrl"
      }
    ],
    "concreteType": "WebInfo",
    "kind": "LinkedField",
    "name": "getSharePointSubsites",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpSubSitesProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpSubSitesProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d56c0d4edeab6cf048a185844b2dedc3",
    "id": null,
    "metadata": {},
    "name": "SpSubSitesProviderQuery",
    "operationKind": "query",
    "text": "query SpSubSitesProviderQuery(\n  $siteUrl: String!\n) {\n  getSharePointSubsites(siteUrl: $siteUrl) {\n    url\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "962f08ff618c0f8121b26fb33a551d31";

export default node;
